import styled from 'styled-components';
import useProgressiveImg from 'hooks/use-progressive-image';

const sharedStyles = `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const Video = styled.video`
  ${sharedStyles}
`;

const Image = styled.img`
  ${sharedStyles}
`;

const LazyMediaItem = ({ media, mediaType, mediaSize }) => {
  if (mediaType === 'VIDEO') {
    // only load mp4 sources
    const videoSources =
      media?.sources?.filter((source) => source.url.includes('.mp4')) || [];
    return (
      <Video autoPlay muted loop playsInline>
        {videoSources.map((source, sourceIndex) => (
          <source
            key={`media-source-item-${sourceIndex}`}
            src={source.url}
            media={
              sourceIndex < videoSources.length - 1
                ? `(width >= ${source.width}px)`
                : null
            }
          />
        ))}
      </Video>
    );
  }

  const currentMediaImage = useProgressiveImg({
    mediaItem: media.previewImage,
    mediaSize: mediaSize,
  });

  return (
    <Image
      ref={currentMediaImage.ref}
      src={currentMediaImage.src}
      alt={media.previewImage.altText}
      style={currentMediaImage.blurStyles}
      decoding='async'
    />
  );
};

export default LazyMediaItem;
